import { t } from '../../i18next';
type ResultType = {
  isValid: boolean;
  errors: { [key: string]: { field: string; msg: string } };
};
export function formOrderValidator(rows, row) {
  const result: ResultType = {
    isValid: true,
    errors: {},
  };
  const filteredRow = rows.filter((item) => {
    return item.status !== 'E';
  });
  if (row.form_order_no !== null) {
    const newCheck = filteredRow.findIndex(
      (item) => item.form_order_no == row.form_order_no && item.form_order_no !== null,
    );
    if (newCheck >= 0) {
      result.isValid = false;
      result.errors.form_order_no = {
        field: 'form_order_no',
        msg: `The selected form order no ${row.form_order_no} already exists`,
      };
    }
  }
  if (
    row.default_value !== null &&
    row.default_value !== '' &&
    row.attr_duplicate_config !== null &&
    row.attr_duplicate_config !== ''
  ) {
    result.isValid = false;
    result.errors.default_value = {
      field: '',
      msg: t('please_fill'),
    };
  }
  return result;
}
